export default [
  {
    title: 'Template set',
    type: 'SelectQuery',
    required: true,
    data: 'templateSets',
    dataIndex: 'template_set',
    selectedKey: 'pk',
    selectedValue: 'name',
    initialValue: '',
    note_text: '',
    // additional: 'edit|add',
    order: 0,
  }, {
    title: 'Name',
    type: 'text',
    required: true,
    dataIndex: 'name',
    data: '',
    initialValue: '',
    note_text: '',
    additional: '',
    order: 1,
  }, {
    title: 'Code',
    type: 'text',
    required: true,
    dataIndex: 'code',
    data: '',
    initialValue: '',
    note_text: '',
    additional: '',
    order: 2,
  },
  {
    title: 'Parents',
    type: 'select_multiple',
    data: 'productParentGroups',
    dataIndex: 'parents',
    initialValue: '',
    note_text: '',
    additional: 'add',
    // minSelected: 2,
    // maxSelected: 3,
    selectedKey: 'pk',
    selectedValue: 'name',
  },
];
